export default __webpack_public_path__ + "static/media/stories-image-6.f8374028.png";